/// <reference path="../../apps/typings/terrific-ext.d.ts"/>
import { UploadModel } from '../models/view/Upload';

export interface UploadEvents {
	startFileUploadListener(event: JQuery.Event): void;
	addFileUploadListener(event: JQuery.Event): void;
	deleteFileUploadListener(event: JQuery.Event): void;
}

export class UploadViewService<T extends BasicAppDefinition> {
	protected readonly $ctx: JQuery;
	protected readonly uploadRowClass: string;
	protected readonly fileStoredClassName: string;
	protected readonly uploadContainerSelector: string;
	protected readonly emitter: T.EventEmitter;

	constructor(options: BasicAppOptions<T>) {
		this.$ctx = options.$ctx;
		this.uploadRowClass = '.js-file-upload';
		this.fileStoredClassName = 'js-file-stored';
		this.uploadContainerSelector = '.js-upload-container';
		this.emitter = new T.EventEmitter(document.applicationInstance._sandbox);
	}

	public addUploadEventListener(handler: UploadEvents): void {
		const $cont = this.$ctx.find(this.uploadContainerSelector);
		const $btn = this.$ctx.find('.js-upload-button');
		if ($btn.length) {
			$btn.on('click', handler.startFileUploadListener.bind(handler));
		} else {
			const $upload = $cont.find('[data-t-name="BasicUpload"]');
			this.emitter.on('damagedeclaration' === ($upload.data('t-decorator') as string).toLowerCase()
				? 'BasicUpload.fileAdded' : 'BasicUpload.onFileSelected', (tgt) => {
					handler.startFileUploadListener({ target: tgt[0], currentTarget: tgt[0] } as JQuery.TriggeredEvent);
				});
		}
		this.$ctx.find('.js-clone-button').on('click', handler.addFileUploadListener.bind(handler));
		$cont.on('UtilsForm.deleteClonedFileWithX', handler.deleteFileUploadListener.bind(handler));
		$cont.on('UtilsForm.deleteClonedRow', handler.deleteFileUploadListener.bind(handler));
	}


	public updateFileView($fileElem: JQuery, guid: string): void {
		$fileElem.addClass(this.fileStoredClassName);
		T.Utils.View.setDataSafe($fileElem, 'js-guid', guid);
	}

	public updateFileSizeSummaryToView($summaryContainer: JQuery, uploadModel: UploadModel): void {

		const $onlySelectedFiles = this.$ctx.find(`.js-data.is-active:not(.${this.fileStoredClassName})`);
		$onlySelectedFiles.each((index, item) => {
			const fsize = $(item).data('js-filesize');
			if (!isNaN(fsize)) {
				uploadModel.FileSizeSum += parseFloat(fsize);
			}
		});

		const $fileSizeSumElem = $summaryContainer.find('.js-fileSizeSum');
		T.Utils.View.setDataSafe($fileSizeSumElem, 'js-rawsize', uploadModel.FileSizeSum);
		$fileSizeSumElem.text(uploadModel.RoundedFileSizeSum);

		const $fileSizeSumUnitElem = $summaryContainer.find('.js-fileSizeSumUnit');
		$fileSizeSumUnitElem.text(uploadModel.FileUnit);

		$summaryContainer.removeClass('is-hidden');
		$summaryContainer.find('.mm-fileSize').removeClass('is-hidden');

	}


	public updateTotalFileSizeToView(uploadModel: UploadModel): void {
		const $fileSizeSumElem = this.$ctx.find('.js-fileSizeSum');
		T.Utils.View.setDataSafe($fileSizeSumElem, 'js-rawsize', uploadModel.FileSizeSum);
		$fileSizeSumElem.text(uploadModel.RoundedFileSizeSum);

		this.$ctx.find('.js-fileSizeSumUnit').text(uploadModel.FileUnit);
	}

	public removeAllFiles($container: JQuery): void {
		if ($container) {
			const $files = $container.find(`.js-data.is-active.${this.fileStoredClassName}`);
			$files.each((index, item) => {
				$(item).parents('.js-file-upload').first().find('.js-clone-remove').trigger('click');
			});
		}
	}

	public setFileStoredClass(elemId: string): void {
		this.$ctx.find(`#${elemId}`).addClass(this.fileStoredClassName);
	}

	public getTriggerdUploadContainerFromView(fileElement: JQuery): JQuery {
		return $(fileElement).closest(this.uploadContainerSelector);
	}

	public getOnlySelectedFilesFromView(container: JQuery): JQuery {
		return $(container).find(`.js-data.is-active:not(.${this.fileStoredClassName})`);
	}

	public getUploadedElementsFromView(uploadContainer: JQuery): JQuery {
		return $(uploadContainer).find(`input[type="file"]:not(.${this.fileStoredClassName})`);
	}

	public getHiddenUploadsFromView(): JQuery {
		return this.$ctx.find('.js-upload-container:hidden');
	}


	public removeFileStoredClass(currentElem: JQuery): void {
		if ($(currentElem).hasClass('js-input-same-row')) {
			const $uploadRow = $(currentElem).parents(this.uploadRowClass).first();
			$uploadRow.removeClass(this.fileStoredClassName);
			$uploadRow.find(`.${this.fileStoredClassName}`).removeClass(this.fileStoredClassName);
		}
	}

	public getUploadedDataElementsFromView(container: JQuery): JQuery {
		return $(container).find('.js-data.is-active.js-file-stored');
	}
}
